export default {
    main_menu: {
        home: 'Главная',
        company: 'Компания',
        my_companies: 'Мои компании',
        reservations: 'Мои бронирования',
        timeline: 'Временная шкала',
        made: 'Сделанные',
        received: 'Полученные',
        locations: 'Местоположения',
        locations_add: ' + Добавить местоположение',
        my_calendar: 'Мой календарь',
        favorites: 'Избранное',
        offers: 'Услуги',
        contact: 'Контакт',
        admin_reservations: 'Oговорки',
        activate_member: 'Активировать участника',
    },
    user_menu: {
        profile: 'Мой профиль',
        go_to_admin_profile: 'Вернуться к профилю администратора',
        logout: 'Выйти',
    },
    top_menu: {
        create_company: 'Создать компанию',
        create_service: 'Создать услугу',
        find_service: 'Найти услугу',
        login: 'Войти',
        find_offers: 'Найти услуги...',
        create_user_offer: 'Как пользователь',
        create_company_offer: 'Как компания',
    },
}
